<div class="admin-dashboard">
  <div class="dashboard-header">
    <div class="header-text">
      <h1>Admin Dashboard</h1>
      <p>Verwalten Sie Benutzerkonten, Rollen und Einmalpasswörter auf einen Blick.</p>
    </div>
    <button mat-raised-button color="primary" (click)="openCreateUserDialog()">
      <mat-icon>person_add</mat-icon>
      <span>Benutzer hinzufügen</span>
    </button>
  </div>

  <div class="stats-grid">
    <mat-card class="stat-card">
      <mat-icon color="primary">group</mat-icon>
      <div class="stat-details">
        <span class="stat-label">Gesamtbenutzer</span>
        <span class="stat-value">{{ totalUsers }}</span>
      </div>
    </mat-card>
    <mat-card class="stat-card">
      <mat-icon color="primary">security</mat-icon>
      <div class="stat-details">
        <span class="stat-label">Admins</span>
        <span class="stat-value">{{ totalAdmins }}</span>
      </div>
    </mat-card>
    <mat-card class="stat-card">
      <mat-icon color="primary">badge</mat-icon>
      <div class="stat-details">
        <span class="stat-label">Standardnutzer</span>
        <span class="stat-value">{{ totalStandardUsers }}</span>
      </div>
    </mat-card>
  </div>

  <mat-card class="table-card">
    <mat-card-header>
      <mat-card-title>Benutzerverwaltung</mat-card-title>
      <mat-card-subtitle>Suche, bearbeiten oder sende neue Einmalpasswörter.</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div class="table-toolbar">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Suche</mat-label>
          <input matInput [value]="filterValue" (input)="applyFilter($any($event.target).value)" placeholder="Name oder E-Mail" />
          <span matSuffix class="suffix-icons">
            <button *ngIf="filterValue" mat-icon-button type="button" aria-label="Filter löschen" (click)="clearFilter()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-icon>search</mat-icon>
          </span>
        </mat-form-field>
      </div>

      <div *ngIf="isLoading" class="loading-state">
        <mat-progress-spinner diameter="48" strokeWidth="4" mode="indeterminate"></mat-progress-spinner>
      </div>

      <ng-container *ngIf="!isLoading">
        <div *ngIf="dataSource.data.length === 0" class="empty-state">
          <mat-icon>group_off</mat-icon>
          <p>Keine Benutzer vorhanden.</p>
        </div>

        <div class="table-wrapper" *ngIf="dataSource.data.length > 0">
          <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
            <ng-container matColumnDef="userName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Benutzername</th>
              <td mat-cell *matCellDef="let user">{{ user.username }}</td>
            </ng-container>

            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>E-Mail</th>
              <td mat-cell *matCellDef="let user">{{ user.email }}</td>
            </ng-container>

            <ng-container matColumnDef="rolle">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Rolle</th>
              <td mat-cell *matCellDef="let user">{{ user.roles }}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Aktionen</th>
              <td mat-cell *matCellDef="let user" class="action-buttons">
                <button mat-icon-button color="primary" matTooltip="Benutzer bearbeiten" (click)="openEditUserDialog(user)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="accent" matTooltip="Einmalpasswort senden"
                        (click)="openResetPasswordDialog(user)"
                        [disabled]="resetInProgress[user.id || '']">
                  <ng-container *ngIf="!resetInProgress[user.id || '']">
                    <mat-icon>key</mat-icon>
                  </ng-container>
                  <mat-progress-spinner *ngIf="resetInProgress[user.id || '']" diameter="20" strokeWidth="3" mode="indeterminate"></mat-progress-spinner>
                </button>
                <button mat-icon-button color="warn" matTooltip="Benutzer löschen" (click)="deleteUser(user.id || '')">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>
